// extracted by mini-css-extract-plugin
module.exports = {"sticky-wrapper":"StickyMenu_sticky-wrapper__291mD","menu":"StickyMenu_menu__3Lq7r","menu__sticky":"StickyMenu_menu__sticky__2ef6n"};